var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivisor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 100,
    viewBox: "0 0 575 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.241 75.5549C314.907 107.148 259.351 107.814 222.576 76.7365C212.807 68.4818 202.91 60.8444 193.653 54.902C125.591 11.2117 0 0 0 0H575C575 0 446.464 9.28984 377.796 54.902C369.267 60.5673 360.206 67.76 351.241 75.5549Z",
    fill: "#FAF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivisor2);
export default __webpack_public_path__ + "static/media/Divisor2.434a5ecb6afc57e02a0e67e38c06fe9d.svg";
export { ForwardRef as ReactComponent };